/** Studio-only key stored in section content; stripped from public API responses. */
export const CREATOR_SITE_AI_DRAFT_CONTENT_KEY = '_aiDraft';

export function canHideCreatorSitePlatformAttribution(hasCreatorPlan: boolean): boolean {
  return hasCreatorPlan;
}

export function resolveCreatorSiteShowPlatformAttribution(input: {
  hidePlatformAttribution: boolean;
  hasCreatorPlan: boolean;
}): boolean {
  if (!input.hidePlatformAttribution) return true;
  return !canHideCreatorSitePlatformAttribution(input.hasCreatorPlan);
}

export function stripCreatorSiteStudioContentFields(
  content: Record<string, unknown>,
): Record<string, unknown> {
  if (!(CREATOR_SITE_AI_DRAFT_CONTENT_KEY in content)) return content;
  const { [CREATOR_SITE_AI_DRAFT_CONTENT_KEY]: _removed, ...rest } = content;
  return rest;
}
